import { useRoot } from "@/composables/useRoot";

export function useSidebar() {
  const $root = useRoot();

  return $root?.$sidebar;
}
